import React, { memo } from 'react'
import Box from 'transfix-ui/core/Box'
import SavedLaneFormBody from './components/SavedLaneFormBody'
import { ISavedLaneFormBodyProps } from './components/SavedLaneFormBody/SavedLaneFormBody'
import SavedLaneFormProvider from './context/SavedLaneFormContext'
import { TSavedLaneSchema } from './schema'
import { IAppTypes } from './types'

export interface ISavedLaneFormProps extends ISavedLaneFormBodyProps {
  /**
   * @default {}
   */
  defaultValues?: TSavedLaneSchema
}

const SavedLaneForm = memo<ISavedLaneFormProps>(
  ({
    app = IAppTypes.marketplace,
    carrierApplicationId,
    defaultValues = {},
    loading,
    onCancel,
    onSubmit,
    onError,
  }) => {
    return (
      <SavedLaneFormProvider context={{ app }} defaultValues={defaultValues}>
        <Box pb={3}>
          <SavedLaneFormBody
            app={app}
            loading={loading}
            carrierApplicationId={carrierApplicationId}
            onSubmit={onSubmit}
            onError={onError}
            onCancel={onCancel}
          />
        </Box>
      </SavedLaneFormProvider>
    )
  }
)

export default SavedLaneForm
